import esLocale from 'element-ui/lib/locale/lang/es'

const es = {
	login: {
		Welcome: 'Bienvenido',
		correct: 'Por favor, ingrese la dirección de correo electrónico correcta',
		enter: 'Por favor, ingrese la contraseña',
		Sign: 'Iniciar sesión',
		Forgot: '¿Olvidó su contraseña?',
		Create: 'Crear una cuenta',
		Password: 'Por favor, ingrese su contraseña',
		Welcome_to_TOZO: 'Bienvenido a TOZO',
		email: 'Por favor, ingrese la dirección de correo electrónico',
		agree: ' * Estoy de acuerdo con',
		Agreement: 'el Acuerdo de Usuario',
		see: '. Por favor, consulte nuestra',
		Policy: 'Política de Privacidad',
		here: ' aquí.',
		Account: 'Crear cuenta',
		account: 'O continúe con su cuenta social',
		email_placeholder: 'Por favor, ingrese su número de cuenta o correo electrónico',
		email_required: 'Por favor, ingrese su número de cuenta o correo electrónico',
		email_correct: 'Por favor, complete la dirección de correo electrónico correcta',
		password_required: 'Por favor, complete la contraseña',
		login_fail: 'fallo al iniciar sesión',
		error_4000: 'El nombre de la aplicación no puede estar vacío o el enlace no existe',
		error_4006: 'Lo siento, el código de verificación que ingresó es incorrecto',
		error_4008: 'Lo siento, la dirección de correo electrónico ya está registrada',
		error_4009: 'Lo siento, la cuenta que ingresó no existe',
		error_4010: 'Lo siento, la contraseña de la cuenta que ingresó es incorrecta'
	},
	register: {
		register_title: 'Cuenta registrada',
		email_placeholder: 'Por favor, ingrese su correo electrónico',
		code_placeholder: 'Por favor, ingrese el código de verificación',
		get: 'Obtener',
		countdownTips: 'El código de verificación es válido por diez minutos',
		password_placeholder: 'Por favor, ingrese la contraseña',
		confirm_password_placeholder: 'Por favor, confirme la contraseña',
		regulation: 'La contraseña debe contener entre 8 y 16 caracteres y ser una combinación de al menos dos de los siguientes: dígitos, letras o símbolos.',
		agree_text1: 'He leído y acepto',
		agree_text2: 'el Acuerdo de Uso de la Cuenta, la Declaración de Privacidad de la Cuenta',
		register_btn: 'Registrarse',
		agree_required: 'Es necesario aceptar el acuerdo',
		password_required: 'Por favor, confirme la contraseña',
		confirmed_and_password_correct: 'La contraseña confirmada es diferente a la ingresada primero',
		email_required: 'Por favor, ingrese la cuenta de correo electrónico',
		email_correct: 'Error en el formato del correo electrónico',
		code_required: 'Por favor, ingrese el código de verificación',
		password_required_js: 'Por favor, ingrese la contraseña',
		password_correct: 'La longitud de la contraseña debe estar entre 8 y 16 caracteres',
		registered: 'Este correo ya está registrado',
		email_format: 'El formato de la dirección de correo electrónico es incorrecto',
		account_required: 'Se requiere una cuenta',
		email_information: 'El código de verificación se envió correctamente. Por favor, revise la información del correo electrónico',
		register_successfully: 'La cuenta de TOZO se registró con éxito'
	},
	reset: {
		reset_title: "Restablecer contraseña",
		old_password_placeholder: 'Por favor, ingrese su antigua contraseña',
		new_password_placeholder: 'Por favor, ingrese su nueva contraseña',
		password_confirmation: 'Por favor, ingrese su nueva contraseña nuevamente',
		reset_btn: 'Restablecer',
		reconfirm_new_password: 'Por favor, confirme nuevamente la nueva contraseña',
		new_password_verify: 'La nueva contraseña ingresada dos veces no coincide con la nueva contraseña',
		password_format: 'La longitud debe estar entre 8 y 16 caracteres',
		password_changed_successfully: 'Contraseña cambiada con éxito'
	},
	forgot: {
		forgot_title: "Encuentra tu contraseña",
		email_placeholder: 'Por favor, ingrese su correo electrónico',
		code_placeholder: 'Por favor, ingrese el código de verificación',
		get: 'Obtener',
		countdownTips: 'El código de verificación es válido por diez minutos',
		password_placeholder: 'Por favor, ingrese la nueva contraseña',
		confirm_password_placeholder: 'Por favor, confirme la nueva contraseña',
		submit_btn: 'ENVIAR',
		password_required: 'Por favor, confirme la nueva contraseña',
		confirmed_and_password_correct: 'La contraseña confirmada es diferente de la ingresada primero',
		email_required: 'Por favor, ingrese la cuenta de correo electrónico',
		email_correct: 'Por favor, ingrese el formato de correo electrónico correcto',
		code_required: 'Por favor, ingrese el código de verificación',
		password_required_js: 'Por favor, ingrese la nueva contraseña',
		password_correct: 'La longitud de la contraseña debe estar entre 8 y 16 caracteres',
		email_information: 'El código de verificación se envió con éxito. Por favor, preste atención a la información del correo electrónico',
		email_verify: 'Por favor, ingrese su correo electrónico',
		forgot_successfully: 'Contraseña modificada con éxito'
	},
	page_404: {
		SORRY: "¡LO SENTIMOS!",
		reserved: "Todos los derechos reservados",
		check_text: "Por favor, verifique que la URL que ingresó es correcta, o haga clic en el botón de abajo para regresar a la página de inicio.",
		Back_Home: "Volver al inicio",
		Get_Support: "Obtener soporte",
		message: "Lo sentimos, no puedes acceder a esta página..."
	},
	nav_box: {
		title: {
			NEW_RELEASES: "Recién llegados",
			HEADPHONES: "AURICULARES",
			WATCHES: "RELOJES",
			SPEAKERS: "ALTAVOCES",
			HOT_SALE: "OFERTAS CALIENTES",
			MID_YEAR_SALE: "Venta de mitad de año",
			GAME_DEALS: "Ofertas de juegos",
			HALLOWEEN_SALE: "Venta de Halloween",
			BLACK_FRIDAY: "VIERNES NEGRO",
			CYBER_MONDAY: "CIBER LUNES",
			DEALS: "OFERTAS",
			CHRISTMAS_SALE: "VENTA DE NAVIDAD",
			HOLIDAY_SALE: 'Venta de vacaciones',
			SOUND_DEALS: "OFERTAS DE SONIDO",
			VALENTINE_S_DAY: "DÍA DE SAN VALENTÍN",
			TOZO_COUPON: "CUPÓN TOZO",
			ST_PATRICK_S_DAY: "Día de San Patricio",
			SPRING_SALE: "OFERTA DE PRIMAVERA",
			EASTER_SALE: "OFERTA DE PASCUA",
			EARTH_DAY_SALE: "OFERTA DÍA TIERRA",
			MOTHERS_DAY_SALE: "OFERTA DEL DÍA DE LA MADRE",
			FATHERS_DAY: "DÍA DEL PADRE",
			INDEPENDENCE_DAY: "INDEPENDENCIA",
			PRIME_DAY: "DÍA PRIME",
			SUMMER_SALE: "OFERTA DE VERANO",
			BACK_TO_SCHOOL: "VUELTA A CLASES",
			NEW_YEAR_SALE: "OFERTA DE AÑO NUEVO",
			SUMMER_DEALS: "Ofertas de verano",
			SUPPORT: "SOPORTE",
			EXPLORE: "EXPLORAR"
		},
		NEW_RELEASES: {
			Shop_All_New_Releases: "Comprar todos los nuevos lanzamientos"
		},
		HEADPHONES: {
			EARBUDS: "AURICULARES",
			OPEN_EAR: "OÍDO ABIERTO",
			OVER_EAR: "ENCIMA DEL OÍDO",
			Active_Noise_Cancelling: "Cancelación activa de ruido",
			Fitness: "Aptitud física",
			Wireless_Charging: "Carga inalámbrica",
			Hi_Res_Audio: "Audio de alta resolución",
			Premium_Call_Quality: "Calidad de llamada premium",
			Gaming: "Juegos",
			Waterproof_Earbuds: "Auriculares impermeables",
			Translate_Earbuds: "Auriculares de traducción",
			Shop_All_Headphones: "Comprar todos los auriculares",
			FILTERING: "FILTRADO"
		},
		WATCHES: {
			Shop_All_Watches: "Comprar todos los relojes"
		},
		SPEAKERS: {
			Shop_All_Speakers: "Comprar todos los altavoces"
		},
		SUPPORT: {
			SERVICES: "SERVICIOS",
			Support_Center: "Centro de soporte",
			Process_Warranty: "Procesar garantía",
			Order_Tracker: "Rastreador de pedidos",
			Privacy_Center: "Centro de privacidad",
			Contact_Us: "Contáctenos",
			FAQs: "Preguntas frecuentes",
			Support_Videos: "Videos de soporte",
			Manuals: "Manuales",
			Warranty_Info: "Información de garantía"
		},
		EXPLORE: {
			ACTIVITIES: "ACTIVIDADES",
			CES_2026: "CES 2026",
			CES_2025: "CES 2025",
			CES_2024: "CES 2024",
			NC20_Available: "NC20 Disponible",
			NC20_Pro_Coming: "NC20 Pro Próximamente",
			TOZO_Coupon: "Cupón TOZO",
			BLACK_FRIDAY: "VIERNES NEGRO",
			CYBER_MONDAY: "CIBER LUNES",
			HOLIDAY_SALE: 'Venta de vacaciones',
			CHRISTMAS_SALE: "VENTA DE NAVIDAD",
			PROMOTION: "PROMOCIÓN",
			HOT_SALE: "OFERTAS CALIENTES",
			Halloween_Sale: "Venta de Halloween",
			SOUND_DEALS: "OFERTAS DE SONIDO",
			VALENTINE_S_DAY: "DÍA DE SAN VALENTÍN",
			TOZOAiryEar: "TOZOAiryEar",
			ST_PATRICK_S_DAY: "Día de San Patricio",
			SPRING_SALE: "OFERTA DE PRIMAVERA",
			EASTER_SALE: "OFERTA DE PASCUA",
			HT3_Coming_Soon: "HT3 Próximamente",
			EARTH_DAY_SALE: "OFERTA DÍA TIERRA",
			MOTHERS_DAY_SALE: "OFERTA DEL DÍA DE LA MADRE",
			FATHERS_DAY: "DÍA DEL PADRE",
			INDEPENDENCE_DAY: "INDEPENDENCIA",
			PRIME_DAY: "DÍA PRIME",
			SUMMER_SALE: "OFERTA DE VERANO",
			Back_To_School: "Vuelta a clases",
			CLUB: "CLUB",
			Blog: "Blog",
			Forum: "Foro",
			BRAND: "MARCA",
			Our_Story: "Nuestra historia",
			Technology: "Tecnología",
			TOZO_FOR_BUSINESS: "TOZO PARA EMPRESAS",
			Dealer_Store: "Tienda de Distribuidores",
			TOZO_Distrbutor_Portal: "Portal de Distribuidores TOZO",
			Become_a_Distribution_Partner: "Conviértete en socio de distribución"
		},
		Account: {
			SIGN_IN: 'INICIAR SESIÓN',
			My_account: 'Mi cuenta',
			Sign_out: 'Cerrar sesión',
		},
	},
	homePage: {
		banner: {
			Welcome: 'Bienvenido a la Comunidad TOZO',
		},
		nav: {
			Home: 'Inicio',
			Followers_list: 'Lista de seguidores',
			Fans_list: 'Lista de fans',
			Personal: 'Personal',
			Messages: 'Mensajes',
		},
	},
	postsArr: {
		Recommand: 'Recomendar',
		Following: 'Siguiendo',
		Say_something: '¿Decir algo?',
		Submit: 'Enviar',
		Follow: 'Seguir',
		Not_interested: 'No interesado',
		Don_t_like_the_author: 'No me gusta el autor',
		Report: 'Reportar',
		Cancel: 'Cancelar',
		Pin: 'Fijar',
		Unpin: 'Desfijar',
		Delete: 'Eliminar',
		Cancel: 'Cancelar',
	},
	FollowersArr: {
		Followers: 'Seguidores',
		Search_for_followers: 'Buscar seguidores',
	},
	FansArr: {
		Fans: 'Fans',
		Search_for_fans: 'Buscar fans'
	},
	PersonalArr: {
		Likes: 'Me gusta',
		Followers: 'Seguidores',
		Fans: 'admirador',
		Posts: 'Publicaciones',
		Media: 'Medios',
		Edit: 'Editar',
	},
	MessagesArr: {
		Comment: 'Comentario',
		Likes: 'Me gusta',
		New_Fans: 'Nuevos fans',
		Comment_you: 'Te comentó',
		Liked_your_comment: 'Le gustó tu comentario',
		Liked_your_post: 'Le gustó tu publicación',
		Followed_you: 'Te siguió.',
		Comment_title: 'Comentario',
		Reply_title: 'Responder',
		Reply: 'Responder',
		View: 'Ver',
		Replies_title: 'Respuestas',
		replies: 'respuestas',
	},
	CommentList: {
		Heat: 'Popular',
		Time: 'Tiempo',
		Reply: 'Responder',
		Delete: 'Eliminar',
		Copy: 'Copiar',
		Cancel: 'Cancelar',
	},
	SearchUserArr: {
		more_users: 'Por favor, introduzca su apodo de usuario',
		Who_to_follow: 'A quién seguir',
	},
	postreportArr: {
		page_title: 'Reportar',
		report_title: 'Por favor, seleccione el tipo de reporte',
		remark_placeholder: 'Describa su problema específico aquí',
		select_report_type: 'Por favor, seleccione el tipo de reporte',
		remark_max_length: 'La descripción del problema puede tener hasta 500 caracteres.',
		validate_all: 'Por favor, verifique los campos obligatorios',
		reportList: {
			Spam_and_Abuse: 'Spam y abuso',
			Pornographic: 'Contenido pornográfico e indecente',
			False_Information: 'Información falsa',
			Intellectual: 'Infracción de propiedad intelectual',
			Personal_safety: 'Seguridad personal y amenazas',
			Hate_Speech: 'Discurso de odio',
			suicide_content: 'Contenido de autolesión o suicidio',
			Account_theft: 'Robo de cuenta o fraude',
			Impersonating_someone_else: 'Hacerse pasar por otra persona',
			Harassment_Report: 'Reporte de acoso',
			Invasion_of_Privacy: 'Invasión de la privacidad',
			Malware_or_links: 'Malware o enlaces',
			Other: 'Otro',
		}
	},
	EditPersonalInformation: {
		page_title: "Editar información personal",
		placeholder: {
			nickname: "Por favor, introduzca el apodo",
			country: "Por favor, seleccione su país/región",
			gender: "Por favor, seleccione su género",
			year: "Seleccione el año",
			month: "Seleccione el mes",
			date: "Seleccione la fecha",
		},
		genderList: {
			male: "masculino",
			female: "femenino",
			other: "otro",
		},
		rules: {
			nickname_required: "Por favor, introduzca un apodo",
			nickname_length: "El apodo debe tener entre 1 y 50 caracteres",
			avatar_required: "Por favor, suba su foto de perfil",
			bg_img_required: "Por favor, suba la imagen de fondo de su página de inicio",
		}
	},
	ConfirmPrompt: {
		delete_tips: '¿Está seguro de que desea eliminar?',
		Your_login: 'Su sesión ha caducado, por favor vuelva a iniciar sesión',
		experience_more: 'Por favor, inicie sesión para experimentar cosas más interesantes',
		Login_Tips: 'Consejos de inicio de sesión',
	},
	SwiperArr: {
		Live: 'En vivo',
	},
	tipsArr: {
		Send_successfully: 'Enviado con éxito',
		Feedback_success: 'Éxito de la retroalimentación',
		Edited_success: 'Editado con éxito',
		Disliked_user: 'El ID de usuario que no le gusta no puede estar vacío',
		System_Error: 'Error del sistema',
		reported_post: 'Ya ha reportado esta publicación',
		user_info_required_fields: 'Por favor, verifique y complete los campos obligatorios',
		network_request: 'La solicitud de red no existe',
	},
	buttonArr: {
		Submit: 'Enviar',
		Follow: 'Seguir',
		Unfollow: 'Liberar',
		Edit: 'Editar',
		Cancel: 'Cancelar',
		Confirm: 'Confirmar',
		Send: 'Enviar',
		Save: 'Ahorrar',
	},
	noDataArr: {
		interesting_things: 'Por favor, inicie sesión para experimentar más cosas interesantes',
		No_data_yet: 'Aún no hay datos',
		follow_list: "Aún no has seguido a nadie",
		fan_home_page: 'Publica contenido interesante para atraer a más personas a seguirte',
		message: 'No hay datos de mensajes',
		comment_module: 'No hay datos de comentarios',
		likes_module: 'Aún no hay datos de me gusta',
		comment_replies_list: 'No hay información de respuestas de comentarios',
		new_fan_follow_list: 'No hay datos de nuevos fans',
		search_user: 'No hay recomendaciones relacionadas',
		go_login: 'Iniciar sesión',
	},
	timeArr: {
		Just_now: 'Justo ahora',
		minute_ago: 'hace un minuto',
		hour_ago: 'hace una hora',
		Yesterday: 'Ayer',
		days_ago: 'hace días',
	},
	FileUploadArr: {
		image_formats: 'Los formatos de archivos de imagen subidos solo admiten ',
		image_size: 'El tamaño de la imagen subida no puede exceder ',
		image_max_text: 'Solo puede subir hasta',
		image_files: 'archivos de imagen',
		video_formats: 'El formato del archivo de video subido solo admite ',
		video_size: 'El tamaño del archivo de video subido no puede exceder ',
		video_max_text: 'Solo puede subir hasta',
		video_files: 'archivos de video',
		avatar_image_formats: 'El formato del archivo de imagen del avatar subido solo admite ',
		avatar_image_size: 'El tamaño máximo del archivo para las imágenes de avatar subidas es ',
		avatar_max_text: 'Solo puede subir hasta',
		avatar_files: 'archivos de imagen de avatar.',
		background_image_formats: 'El formato del archivo de imagen de fondo subido solo admite ',
		background_image_size: 'El tamaño máximo del archivo para las imágenes de fondo subidas es ',
		background_max_text: 'Solo puede subir hasta',
		background_files: 'archivos de imagen de fondo.',
	},
	loading: "cargando",

  ...esLocale
}

export default es
